"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleProxyAppAssetSchemaListResponseSchema = exports.AppleProxyAppAssetSchema = exports.AppleProxyAppAssetsParamsSchema = exports.AppleProxyAdCreativeListRejectionReasonsResponseSchema = exports.AppleProxyAdCreativeRejectionReasonsResponseSchema = exports.AppleProxyAdCreativeRejectionReasonsSchema = exports.AppleProxyReasonTypeSchema = exports.AppleProxyReasonLevelSchema = exports.AppleProxyReasonCodeSchema = exports.AppleProxyProductPageRegionParamsSchema = exports.AppleProxyAppPreviewDevicesMappingResponseSchema = exports.AppleProxySupportedCountriesOrRegionsListResponseSchema = exports.AppleProxyProductPageLocaleDetailListResponseSchema = exports.AppleProxyProductPageLocaleDetailSchema = exports.AppleProxyProductPageDetailListResponseSchema = exports.AppleProxyProductPageDetailResponseSchema = exports.AppleProxyProductPageDetailSchema = exports.AppleProxySupportedCountriesOrRegionsQuerySchema = exports.AppleProxyListLocalesQuerySchema = exports.AppleProxyAdamProductPageRefParamsSchema = exports.AppleProxyProductPageQuerySchema = exports.AppleProxySupportedCountryOrRegionSchema = exports.AppleProxyOrientationSchema = exports.AppleProxyAssetTypeSchema = exports.AppleProxyCustomProductPageNameSchema = exports.AppleProxyCustomProductPageRefSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const campaigns_1 = require("./campaigns");
const core_2 = require("./core");
// Basic DTO Types for Custom Product Pages
// Product pages aren't integer ids
exports.AppleProxyCustomProductPageRefSchema = typebox_1.Type.String();
exports.AppleProxyCustomProductPageNameSchema = typebox_1.Type.String();
const AppleProxyAppNameSchema = typebox_1.Type.String();
const AppleProxyCustomProductPageStateSchema = (0, core_1.StringUnion)([
    "VISIBLE",
    "HIDDEN",
]);
const AppleProxyDeviceClassListSchema = typebox_1.Type.Array(core_2.AppleProxyDeviceClassSchema);
exports.AppleProxyAssetTypeSchema = (0, core_1.StringUnion)([
    "APP_PREVIEW",
    "SCREENSHOT",
]);
exports.AppleProxyOrientationSchema = (0, core_1.StringUnion)([
    "PORTRAIT",
    "LANDSCAPE",
    "UNKNOWN",
]);
const appAsset = {
    assetGenId: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    assetType: (0, core_1.OptionalNullable)(exports.AppleProxyAssetTypeSchema),
    assetUrl: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    orientation: (0, core_1.OptionalNullable)(exports.AppleProxyOrientationSchema),
    sortPosition: (0, core_1.OptionalNullable)(typebox_1.Type.Integer()),
    sourceHeight: (0, core_1.OptionalNullable)(typebox_1.Type.Integer()),
    sourceWidth: (0, core_1.OptionalNullable)(typebox_1.Type.Integer()),
};
const AppleProxyMediaAppAssetSchema = typebox_1.Type.Object({
    ...appAsset,
});
const AppleProxyMediaAppAssetListSchema = typebox_1.Type.Array(AppleProxyMediaAppAssetSchema);
const AppleProxyLocaleInfoSchema = typebox_1.Type.Object({
    language: (0, core_1.OptionalNullable)(core_2.LanguageSchema),
    languageCode: (0, core_1.OptionalNullable)(core_2.LanguageCodeSchema),
});
const AppleProxyCountryOrRegionsSchema = typebox_1.Type.String();
exports.AppleProxySupportedCountryOrRegionSchema = typebox_1.Type.Object({
    countryOrRegion: (0, core_1.OptionalNullable)(AppleProxyCountryOrRegionsSchema),
    supportedLanguages: (0, core_1.OptionalNullable)(typebox_1.Type.Array(AppleProxyLocaleInfoSchema)),
    defaultLanguage: (0, core_1.OptionalNullable)(AppleProxyLocaleInfoSchema),
});
const AppleProxyAppPreviewDevicesMappingResponseDataSchema = typebox_1.Type.Record(typebox_1.Type.String(), typebox_1.Type.String());
const AppleProxyMediaAppAssetsDetailSchema = typebox_1.Type.Object({
    appPreviewDeviceFallBackDevices: (0, core_1.OptionalNullable)(typebox_1.Type.Array(typebox_1.Type.String())),
    appPreviews: (0, core_1.OptionalNullable)(AppleProxyMediaAppAssetListSchema),
    screenshots: (0, core_1.OptionalNullable)(AppleProxyMediaAppAssetListSchema),
});
/**
 * API Parameter Types
 */
exports.AppleProxyProductPageQuerySchema = (0, core_1.StrictObject)({
    name: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    states: (0, core_1.OptionalNullable)(AppleProxyCustomProductPageStateSchema),
});
exports.AppleProxyAdamProductPageRefParamsSchema = (0, core_1.StrictObject)({
    adamId: core_2.AppleProxyAdamRefSchema,
    productPageId: exports.AppleProxyCustomProductPageRefSchema,
});
exports.AppleProxyListLocalesQuerySchema = (0, core_1.StrictObject)({
    expand: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
    languages: (0, core_1.OptionalNullable)(core_2.LanguageSchema),
    languageCodes: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    deviceClasses: (0, core_1.OptionalNullable)(core_2.AppleProxyDeviceClassSchema),
});
exports.AppleProxySupportedCountriesOrRegionsQuerySchema = (0, core_1.StrictObject)({
    countriesOrRegions: (0, core_1.OptionalNullable)(AppleProxyCountryOrRegionsSchema),
});
/**
 * API Response types
 */
exports.AppleProxyProductPageDetailSchema = typebox_1.Type.Object({
    adamId: (0, core_1.OptionalNullable)(core_2.AppleProxyAdamRefSchema),
    creationTime: (0, core_1.OptionalNullable)(core_2.AppleProxyDateTimeSchema),
    id: (0, core_1.OptionalNullable)(exports.AppleProxyCustomProductPageRefSchema),
    modificationTime: (0, core_1.OptionalNullable)(core_2.AppleProxyDateTimeSchema),
    name: exports.AppleProxyCustomProductPageNameSchema,
    state: (0, core_1.OptionalNullable)(AppleProxyCustomProductPageStateSchema),
    deepLink: (0, core_1.OptionalNullable)(core_1.UrlSchema),
});
exports.AppleProxyProductPageDetailResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(exports.AppleProxyProductPageDetailSchema),
});
const AppleProxyProductPageDetailList = typebox_1.Type.Array(exports.AppleProxyProductPageDetailSchema);
exports.AppleProxyProductPageDetailListResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(AppleProxyProductPageDetailList),
});
exports.AppleProxyProductPageLocaleDetailSchema = typebox_1.Type.Object({
    adamId: (0, core_1.OptionalNullable)(core_2.AppleProxyAdamRefSchema),
    appName: AppleProxyAppNameSchema,
    appPreviewDeviceWithAssets: (0, core_1.OptionalNullable)(typebox_1.Type.Record(typebox_1.Type.String(), AppleProxyMediaAppAssetsDetailSchema)),
    deviceClasses: (0, core_1.OptionalNullable)(AppleProxyDeviceClassListSchema),
    language: (0, core_1.OptionalNullable)(core_2.LanguageSchema),
    productPageId: (0, core_1.OptionalNullable)(exports.AppleProxyCustomProductPageRefSchema),
    promotionalText: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    shortDescription: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    subTitle: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
});
const AppleProxyProductPageLocaleDetailsListSchema = typebox_1.Type.Array(exports.AppleProxyProductPageLocaleDetailSchema);
exports.AppleProxyProductPageLocaleDetailListResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(AppleProxyProductPageLocaleDetailsListSchema),
});
exports.AppleProxySupportedCountriesOrRegionsListResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(typebox_1.Type.Array(exports.AppleProxySupportedCountryOrRegionSchema)),
});
exports.AppleProxyAppPreviewDevicesMappingResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(AppleProxyAppPreviewDevicesMappingResponseDataSchema),
});
exports.AppleProxyProductPageRegionParamsSchema = typebox_1.Type.Object({
    productPageReasonId: typebox_1.Type.Number(),
});
exports.AppleProxyReasonCodeSchema = (0, core_1.StringUnion)([
    "APP_ICON_GRAPHIC_OR_ADULT_THEMED_CONTENT",
    "APP_ICON_NOT_ELIGIBLE",
    "APP_NAME_LANGUAGE_CONFLICT",
    "APP_NAME_GRAPHIC_OR_ADULT_THEMED_CONTENT",
    "APP_NAME_NOT_ELIGIBLE",
    "APP_NOT_ELIGIBLE_AT_THIS_TIME",
    "MIMICS_APP_STORE_TODAY_CARD",
    "PRODUCT_PAGE_OPTIMIZATION_EXPERIMENT_APP_ICON_NOT_ELIGIBLE",
    "SUBTITLE_GRAPHIC_OR_ADULT_THEMED_CONTENT",
    "SUBTITLE_LANGUAGE_CONFLICT",
    "SUBTITLE_NOT_ELIGIBLE",
    "SUBTITLE_PRICING_OFFERS_OR_RANKING_CLAIMS",
]);
exports.AppleProxyReasonLevelSchema = (0, core_1.StringUnion)([
    "CUSTOM_PRODUCT_PAGE_LOCALE",
    "DEFAULT_PRODUCT_PAGE",
    "DEFAULT_PRODUCT_PAGE_LOCALE",
]);
exports.AppleProxyReasonTypeSchema = (0, core_1.StringUnion)(["REJECTION_REASON"]);
exports.AppleProxyAdCreativeRejectionReasonsSchema = typebox_1.Type.Object({
    id: core_1.IdSchema,
    adamId: core_2.AppleProxyAdamRefSchema,
    productPageId: exports.AppleProxyCustomProductPageRefSchema,
    assetGenId: typebox_1.Type.String(),
    supplySource: campaigns_1.AppleProxySupplySourceSchema,
    countryOrRegion: AppleProxyCountryOrRegionsSchema,
    languageCode: core_2.LanguageCodeSchema,
    reasonType: exports.AppleProxyReasonTypeSchema,
    reasonLevel: exports.AppleProxyReasonLevelSchema,
    reasonCode: exports.AppleProxyReasonCodeSchema,
    comment: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
});
exports.AppleProxyAdCreativeRejectionReasonsResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(exports.AppleProxyAdCreativeRejectionReasonsSchema),
});
exports.AppleProxyAdCreativeListRejectionReasonsResponseSchema = typebox_1.Type.Object({
    data: typebox_1.Type.Array(exports.AppleProxyAdCreativeRejectionReasonsSchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
exports.AppleProxyAppAssetsParamsSchema = typebox_1.Type.Object({
    adamId: core_2.AppleProxyAdamRefSchema,
});
exports.AppleProxyAppAssetSchema = typebox_1.Type.Object({
    adamId: core_2.AppleProxyAdamRefSchema,
    ...appAsset,
});
exports.AppleProxyAppAssetSchemaListResponseSchema = typebox_1.Type.Object({
    data: typebox_1.Type.Array(exports.AppleProxyAppAssetSchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
